var styleDataHash = "53694f00";
const injectCss = () => {
  var css = `.C92Y7,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.zIdNZ{position:relative;top:0;width:100%}[dir=ltr] .zIdNZ{left:0}[dir=rtl] .zIdNZ{right:0}.zIdNZ:before{content:"";height:100%;position:absolute;top:0;width:100%;z-index:5}[dir] .zIdNZ:before{cursor:move}[dir=ltr] .zIdNZ:before{left:0}[dir=rtl] .zIdNZ:before{right:0}.MO59k{color:var(--ricos-custom-link-color,var(--ricos-action-color,#116dff));font-family:var(--ricos-custom-link-font-family,unset);font-size:var(--ricos-custom-link-font-size,unset);font-style:var(--ricos-custom-link-font-style,unset);font-weight:var(--ricos-custom-link-font-weight,unset);letter-spacing:var(--ricos-custom-link-letter-spacing,unset);line-height:var(--ricos-custom-link-line-height,unset);min-height:var(--ricos-custom-link-min-height,unset);text-decoration:var(--ricos-custom-link-text-decoration,none)}@supports not (contain:inline-size){@media only screen and (max-width:640px){.MO59k{font-size:var(--ricos-custom-link-font-size,unset)}}}@container (width < 640px){.MO59k{font-size:var(--ricos-custom-link-font-size,unset)}}[dir] .eRzaf:hover{cursor:pointer}.vlE9q{color:var(--ricos-text-color,#212121)}.vlE9q:before{content:"";height:2px;position:absolute;top:-2px;width:2px}[dir] .vlE9q:before{border:2px solid #116dff;border-radius:50%}[dir=ltr] .vlE9q:before{left:-5px}[dir=rtl] .vlE9q:before{right:-5px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var styles_default = {
  "fontElementMap": "C92Y7",
  "overlay": "zIdNZ",
  "link": "MO59k",
  "linkInViewer": "eRzaf",
  "dropcursor": "vlE9q"
};
export {
  styles_default as default,
  injectCss
};
//# sourceMappingURL=styles-scss.js.map
